exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-92dca4da]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin:.9615rem .7692rem;-webkit-column-gap:10px;-moz-column-gap:10px;column-gap:10px;font-size:.6923rem}.pagination span[data-v-92dca4da]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;min-width:1.1538rem;height:1.1538rem;line-height:1.1538rem;text-align:center;background:#f4f4f5;color:#606266;border-radius:2px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 .1538rem}.pagination .is-active[data-v-92dca4da]{background:#ff7802;color:#fff}.pagination .is-disabled[data-v-92dca4da]{cursor:no-drop}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-92dca4da","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/pagination.vue
// module id = vxbN
// module chunks = 25 28 29 31 32 33 34 41